import { useMutation, useQueryClient } from 'react-query'
import { updateCashAdvancePayoutMechanism } from '../api/merchant-cash-advances.api'
import { UpdateCashAdvancePayoutMechanismDTO } from '../dtos/merchant-cash-advance.dto'

export const useUpdateCashAdvancePayoutMechanism = (merchantId: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    (payload: UpdateCashAdvancePayoutMechanismDTO) => {
      return updateCashAdvancePayoutMechanism(merchantId, payload)
    },
    {
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: ['cash-advances', merchantId],
        }),
    },
  )
}
